// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"210cea12","977":"9bf7c710"}[chunkId] + ".chunk.js";
};